import ChatApp from './Chat';
import Header from './header';
import './output.css';

function App() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Header />
      <ChatApp />
    </div>
  );
}

export default App;
